import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M12 2a9 9 0 0 0-9 9c0 .86.31 1.855.891 2.944.577 1.081 1.385 2.19 2.296 3.26 1.823 2.138 3.98 4.027 5.28 5.096.315.26.75.26 1.066 0 1.3-1.069 3.457-2.958 5.28-5.097.911-1.069 1.72-2.178 2.296-3.259.58-1.09.891-2.085.891-2.944a9 9 0 0 0-9-9ZM1 11C1 4.925 5.925 0 12 0s11 4.925 11 11c0 1.314-.464 2.643-1.126 3.885-.668 1.251-1.572 2.481-2.539 3.616-1.933 2.268-4.192 4.243-5.531 5.344a2.828 2.828 0 0 1-3.608 0c-1.339-1.101-3.598-3.076-5.531-5.344-.967-1.135-1.872-2.365-2.539-3.616C1.464 13.643 1 12.314 1 11Zm11-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
